import { FC, memo, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

type PageTitleViewType = { title: string; iconPath?: string };

type PageTitleType = PageTitleViewType & { children?: ReactNode };

const PageTitleView: FC<PageTitleViewType> = memo(
  ({ title, iconPath = '/assets/icons/file_icon.svg' }) => {
    return (
      <div className="page-title">
        <div className="container">
          <div className="page-title__wrapper">
            <img
              src={iconPath}
              alt="left page title icon"
              className="page-title__img page-title__img--left"
            />
            <h2 className="title title--h2 title--white">{title}</h2>
            <img
              src={iconPath}
              alt="right page title icon"
              className="page-title__img page-title__img--right"
            />
          </div>
        </div>
      </div>
    );
  },
  (prev, next) => {
    if (prev.title !== next.title) {
      return false;
    } else if (prev.iconPath !== next.iconPath) {
      return false;
    }

    return true;
  },
);

const PageTitle: FC<PageTitleType> = ({ children, ...rest }) => {
  return (
    <>
      <PageTitleView {...rest} />
      {children || <Outlet />}
    </>
  );
};

export default PageTitle;
